// import "slick-carousel";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
// import Swiper and modules styles
import "swiper/swiper.css";
import "swiper/modules/navigation.css";
import "swiper/modules/pagination.scss";

export function sliders(slider) {
  for (var i = 0; i < slider.length; i++) {
    var thisSlider = slider.eq(i),
      arrow = thisSlider.data("arrows"),
      arrow = arrow?.split("_")[1],
      thisChildren = thisSlider.children(".swiper-wrapper").children(),
      isUnresponsive = thisSlider.hasClass("unresponsive"),
      isEinheit = thisChildren.hasClass("is_einheit"),
      isGalerie = thisChildren.hasClass("is_galerie"),
      isTestimonial = thisChildren.hasClass("is_testimonial");
    console.log(
      i,
      thisSlider,
      thisChildren,
      isEinheit,
      isGalerie,
      isTestimonial
    );
    // console.log("import slickslider.mjs", slider);
    console.log("swiper instance", slider.eq(i)[0]);
    var prev = document.querySelector("#nav_" + arrow + "-prev");
    var next = document.querySelector("#nav_" + arrow + "-next");
    console.log("slider, prev, next", thisSlider, prev, next);
    const breakpoints = {
      1366: {
        slidesPerView: isEinheit ? 3 : 2,
        rewind: true,
        autoplay: isEinheit ? false : isGalerie ? false : false,
        centeredSlides: isGalerie ? true : false,
        // settings: {
        //   useTransform: false,
        //   // variabel heißt, kann ich selber einstellen über die CSS (kann atmen), JS schreibt nichts festes in die DIVs
        //   variableWidth: isEinheit
        //     ? true
        //     : isTestimonial
        //     ? false
        //     : isGalerie
        //     ? true
        //     : false,
        //   adaptiveHeight: isTestimonial ? false : true,
        // },
      },
      1024: {
        slidesPerView: isGalerie ? 1 : isTestimonial ? 1 : 2,
        rewind: true,
        autoplay: isEinheit ? false : isGalerie ? false : false,
        centeredSlides: isGalerie ? true : false,
        settings: {
          lazyLoad: "ondemand",
          variableWidth: isEinheit
            ? false
            : isTestimonial
            ? false
            : isGalerie
            ? true
            : false,
          centerMode: isTestimonial ? false : isGalerie ? true : false,
          centerPadding: isGalerie ? "30px" : isTestimonial ? 0 : "0px",
          adaptiveHeight: isTestimonial ? false : isGalerie ? true : false,
          // autoplay: isEinheit ? false : (isGalerie ? true : false),
        },
      },
      1: {
        slidesPerView: isGalerie ? 1 : 1,
        rewind: true,
        autoplay: isEinheit ? false : isGalerie ? false : false,
        centeredSlides: isGalerie ? true : false,
        settings: {
          lazyLoad: "ondemand",
          variableWidth: isEinheit
            ? false
            : isTestimonial
            ? false
            : isGalerie
            ? true
            : false,
          centerMode: isTestimonial ? false : isGalerie ? true : false,
          centerPadding: isGalerie ? "30px" : isTestimonial ? 0 : "0px",
          adaptiveHeight: isTestimonial ? false : isGalerie ? true : false,
          infinite: true,
          // autoplay: isEinheit ? false : (isGalerie ? true : false),
        },
      },
    };

    const swiper = new Swiper(slider.eq(i)[0], {
      slidesPerView: "auto",
      spaceBetween: 10,
      loop: true,
      autoHeight: false,
      height: 400,
      // autoplay: true,
      modules: [Navigation, Pagination],
      navigation: {
        enabled: true,
        nextEl: next ? next : undefined,
        prevEl: prev ? prev : undefined,
      },
      //breakpoints
    });
    // slider.eq(i).slick({
    //   // dots: true,
    //
    //   infinite: true,
    //   arrows: true,
    //   appendArrows: arrow,
    //
    //   // ---
    //   slidesToShow: isEinheit ? 3 : 2,
    //   infinite: true,
    //   useTransform: false,
    //   // ---
    //
    //   // slidesToShow: isEinheit ? 3 : 3,
    //   // slidesToScroll: 1,
    //   // autoplay: false,
    //   // autoplaySpeed: 2000,
    //
    //   // centerMode: true,
    //   // centerPadding: '400px',
    //   // variableWidth: true,
    //
    //   lazyLoad: 'ondemand',
    //   responsive: isUnresponsive
    //     ? null
    //     : [
    //         //   {
    //         //     breakpoint: 9999,
    //         //     settings: 'unslick'
    //         //   },
    //         {
    //           breakpoint: 1366,
    //           settings: {
    //             slidesToShow: isEinheit ? 3 : 2,
    //             infinite: true,
    //             useTransform: false,
    //             // variabel heißt, kann ich selber einstellen über die CSS (kann atmen), JS schreibt nichts festes in die DIVs
    //             variableWidth: isEinheit
    //               ? true
    //               : isTestimonial
    //               ? false
    //               : isGalerie
    //               ? true
    //               : false,
    //             autoplay: isEinheit ? false : isGalerie ? false : false,
    //             centerMode: isGalerie ? true : false,
    //             centerPadding: isGalerie ? "0" : "0",
    //             adaptiveHeight: isTestimonial ? false : true,
    //             // lazyLoad: "ondemand",
    //           },
    //         },
    //         {
    //           // breakpoint: 576,
    //           breakpoint: 1024,
    //           settings: {
    //             lazyLoad: "ondemand",
    //             slidesToShow: isGalerie ? 1 : isTestimonial ? 1 : 2,
    //             variableWidth: isEinheit
    //               ? false
    //               : isTestimonial
    //               ? false
    //               : isGalerie
    //               ? true
    //               : false,
    //             centerMode: isTestimonial ? false : isGalerie ? true : false,
    //             centerPadding: isGalerie ? "30px" : isTestimonial ? 0 : "0px",
    //             adaptiveHeight: isTestimonial
    //               ? false
    //               : isGalerie
    //               ? true
    //               : false,
    //             infinite: true,
    //             // autoplay: isEinheit ? false : (isGalerie ? true : false),
    //           },
    //         },
    //         {
    //           // breakpoint: 576,
    //           breakpoint: 561,
    //           settings: {
    //             lazyLoad: "ondemand",
    //             slidesToShow: isGalerie ? 1 : 1,
    //             variableWidth: isEinheit
    //               ? false
    //               : isTestimonial
    //               ? false
    //               : isGalerie
    //               ? true
    //               : false,
    //             centerMode: isTestimonial ? false : isGalerie ? true : false,
    //             centerPadding: isGalerie ? "30px" : isTestimonial ? 0 : "0px",
    //             adaptiveHeight: isTestimonial
    //               ? false
    //               : isGalerie
    //               ? true
    //               : false,
    //             infinite: true,
    //             // autoplay: isEinheit ? false : (isGalerie ? true : false),
    //           },
    //         },
    //       ],
    // });
  }
}
